<template>
  <v-card
    id="encours"
    fluid
  >

  <v-dialog v-model="dialog_calendar"
    max-width="1000"
    style="z-index: 1000"
    :retain-focus="false"
  >
    <v-btn
      icon
      class="ma-2"
      @click="close_calendar"
    >
      close
    </v-btn>

    <v-card flat>
      
      <v-card-title>
        
        <span class="headline" >un titre pour cle calendrier de Luka
        </span>

      </v-card-title>
    <v-card> 

        
  <div>
  <v-sheet
  tile
  height="54"
  class="d-flex"
  >
  <v-btn
  icon
  class="ma-2"
  @click="$refs.calendar.prev()"
  >
  <v-icon>mdi-chevron-left</v-icon>
  </v-btn>
  <v-select
    v-model="type"
    :items="types"
    dense
    outlined
    hide-details
    class="ma-2"
    label="type"
  ></v-select>
  <v-select
    v-model="mode"
    :items="modes"
    dense
    outlined
    hide-details
    label="event-overlap-mode"
    class="ma-2"
  ></v-select>
  <v-select
    v-model="weekday"
    :items="weekdays"
    dense
    outlined
    hide-details
    label="weekdays"
    class="ma-2"
  ></v-select>
  <v-spacer></v-spacer>
  <v-btn
    icon
    class="ma-2"
    @click="$refs.calendar.next()"
  >
  <v-icon>mdi-chevron-right</v-icon>
  </v-btn>
  </v-sheet>
  <v-sheet height="600">
  <v-calendar
    ref="calendar"
    v-model="value"
    :weekdays="weekday"
    :type="type"
    :events="events"
    :event-overlap-mode="mode"
    :event-overlap-threshold="30"
    :event-color="getEventColor"
    @change="getEvents"
    @click:event="luka"
  ></v-calendar>



  </v-sheet>
  </div>
  </v-card>

        
    </v-card>
    
  </v-dialog>
  <v-dialog
      v-model="dialog"
      width="auto"
    >
  <v-card>
        <v-card-text>
         
        </v-card-text>
      </v-card>
  </v-dialog>
  <v-dialog
      v-model="d_tecnical_report_nuit"
      fullscreen
    >
  <v-card>
    <v-btn
        class="ma-2"
        @click="report_nuit_close"
      >
        Close
  </v-btn>
  {{ click_nuit }} 
<v-app id="inspire">
    <v-data-table
      :headers="headers"
      :items="click_data_journalisation"
      @click:row="edit_tblreport_obs"
    >
    <template v-slot:top>
      <v-toolbar
        flat
      >

        <v-spacer></v-spacer>
        <v-dialog
          v-model="D_edit_tblreport_obs_u"
          
        >

          <v-card>
            <v-card-title>
              <span class="text-h5">{{a_report.nom_og}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  
                  <v-col cols="12"  sm="1"  md="2"  >
                    <v-text-field disabled
                      v-model="a_report.nom_objet"  label="Objet"
                    ></v-text-field>jfjjfj
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ha1"  label="ha1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ha2"  label="ha2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.am1"  label="am1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.am2"  label="am2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.magv"  label="magv"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.spt"  label="spt"
                    ></v-text-field>
                  </v-col>


                </v-row>
                
                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.tt"  label="tt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.p"  label="p"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.m"  label="m"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>              
                  
                </v-row>


                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-combobox
                      v-model="a_report.state"
                      :items="c_status"
                      label="Status"

                    ></v-combobox>

                  </v-col>

                  <v-col  cols="12"  sm="9"  md="9">
                  <v-text-field 
                      v-model="a_report.remarks"  label="Remarques"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1" v-if="false" >
                    <v-text-field disabled
                      v-model="a_report.valider"  label="valider"
                    ></v-text-field>
                  </v-col>

                  
                </v-row>

              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="Annuler_obs"
              >
                Annuler
              </v-btn>
              <v-btn
                color="green"
                text
                @click="Sauvegarder_obs"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog
          v-model="D_edit_tblreport_full"
          
        >

          <v-card>
            <v-card-title>
              <span class="text-h5">{{a_report.nom_og}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12"  sm="1"  md="2"  >
                    <v-text-field 
                      v-model="a_report.nom_objet"  label="Objet"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ha1"  label="ha1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ha2"  label="ha2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.am1"  label="am1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.am2"  label="am2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.magv"  label="magv"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.spt"  label="spt"
                    ></v-text-field>
                  </v-col>
               </v-row>
                 <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.tt"  label="tt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>                      
                      multiple
                      outlined
                      dense
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.p"  label="p"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.m"  label="m"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>              
                </v-row>

                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                  <v-text-field
                      v-model="a_report.state"  label="Status"
                    ></v-text-field>
                  </v-col>

                  <v-col  cols="12"  sm="9"  md="9">
                  <v-text-field
                      v-model="a_report.remarks"  label="Remarques"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.valider"  label="valider"
                    ></v-text-field>
                  </v-col>

                  
                </v-row>

              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="click_a_la_con"
              >
                Annuler
              </v-btn>
              <v-btn
                color="green"
                text
                @click="Sauvegarder"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    </v-data-table>
  </v-app>

</v-card>
</v-dialog>
  <v-dialog
      v-model="dialog_calendar_old"
      overlay-color="black"
      overlay-opacity="1"
    >
    <v-card > 

        <v-sheet
          tile
          height="54"
          class="d-flex"
        
        >
          <v-btn
            icon
            class="ma-2"
            @click="$refs.calendar.prev()"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
          </v-toolbar-title>



          <v-btn
            icon
            class="ma-2"
          
            @click="$refs.calendar.next()"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>

        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="value"
            :weekdays="weekday"
            :type="type"
            :events="Observations"
            :event-overlap-mode="mode"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
            @change="getEvents"
            @click:day="(event)=>dateClick(event,true)"
            
            category-show-all="true"
          ></v-calendar>



        </v-sheet>

      <v-text-field
              label="date"
              type="date"
              v-model="la_date"
              :append-inner-icon="mdi-map-marker"


            ></v-text-field>
    </v-card>
  </v-dialog>
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">Journalisation Nuit : {{nuit}}</span>

  </v-card-title>
  

<v-card>
  <v-row>
    <v-col
      cols="6"
      sm="2"
      md="2"
    >
      <v-card>

        <v-btn v-if="false"
          icon
          class="ma-2"
          @click="open_calendar"
        >
          .
        </v-btn>
        <v-icon v-if="true"
                @click="open_calendar"
              >
                mdi-calendar
              </v-icon>
      </v-card>
    </v-col>

  </v-row>
</v-card>
<v-card> 
  <div id="app">
  <v-app id="inspire">
    <v-data-table
      :headers="headers"
      :items="data_journalisation"
      items-per-page="100"
      @click:row="edit_tblreport_obs"
    >
    <template v-slot:top>
      <v-toolbar
        flat
      >
      <v-card-text>
        <v-container>
          <v-row>

            <v-col cols="12"  sm="3"  md="3"  >
                    <v-combobox
                      v-model="a_report_nuit.state"
                      :items="c_status"
                      label="Status"

                    ></v-combobox>

                  </v-col>

                  <v-col  cols="12"  sm="7"  md="7">
                  <v-text-field 
                      v-model="a_report_nuit.remarks"  label="Remarques"
                    ></v-text-field>
                  </v-col>

            <v-col cols="12"  sm="2"  md="2"  >
              <v-btn v-if="true"
                @click="Sauvegarder_allobs"
              >
                Pour la Nuit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>    
        <v-spacer></v-spacer>
        <v-dialog
          v-model="D_edit_tblreport_obs"
          
        >

          <v-card>
            <v-card-title>
              <span class="text-h5">{{a_report.nom_og}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12"  sm="1"  md="2"  >
                    <v-text-field disabled
                      v-model="a_report.nom_objet"  label="Objet"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ha1"  label="ha1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ha2"  label="ha2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.am1"  label="am1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.am2"  label="am2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.magv"  label="magv"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.spt"  label="spt"
                    ></v-text-field>
                  </v-col>


                </v-row>
                
                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.tt"  label="tt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.p"  label="p"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.m"  label="m"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field disabled
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>              
                  
                </v-row>


                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-combobox
                      v-model="a_report.state"
                      :items="c_status"
                      label="Status"

                    ></v-combobox>

                  </v-col>

                  <v-col  cols="12"  sm="9"  md="9">
                  <v-text-field 
                      v-model="a_report.remarks"  label="Remarques"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1" v-if="false" >
                    <v-text-field disabled
                      v-model="a_report.valider"  label="valider"
                    ></v-text-field>
                  </v-col>

                  
                </v-row>

              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="Annuler_obs"
              >
                Annuler
              </v-btn>
              <v-btn
                color="green"
                text
                @click="Sauvegarder_obs"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="D_edit_tblreport_full"
          
        >

          <v-card>
            <v-card-title>
              <span class="text-h5">{{a_report.nom_og}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12"  sm="1"  md="2"  >
                    <v-text-field 
                      v-model="a_report.nom_objet"  label="Objet"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ha1"  label="ha1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ha2"  label="ha2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.am1"  label="am1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.am2"  label="am2"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.magv"  label="magv"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.spt"  label="spt"
                    ></v-text-field>
                  </v-col>


                </v-row>
                
                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.tt"  label="tt"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>                      multiple
                      outlined
                      dense
                  </v-col>

                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.p"  label="p"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.m"  label="m"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.ts"  label="ts"
                    ></v-text-field>
                  </v-col>              
                  
                </v-row>


                <v-row>
                  <v-col cols="12"  sm="1"  md="1"  >
                  <v-text-field
                      v-model="a_report.state"  label="Status"
                    ></v-text-field>
                  </v-col>

                  <v-col  cols="12"  sm="9"  md="9">
                  <v-text-field
                      v-model="a_report.remarks"  label="Remarques"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12"  sm="1"  md="1"  >
                    <v-text-field
                      v-model="a_report.valider"  label="valider"
                    ></v-text-field>
                  </v-col>

                  
                </v-row>

              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="click_a_la_con"
              >
                Annuler
              </v-btn>
              <v-btn
                color="green"
                text
                @click="Sauvegarder"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>



    
    </v-data-table>
  </v-app>
</div>

</v-card>



  </v-card>




</template>
<script>
  
  export default {
    data_old: () =>({
      tel:{
        lastpos:{"timestamp":"2073-04-01T00:00:00.000Z","st":"12h00m00s","ah":"+6h00m00s","ra":0.0,"dec":0.0,"airmass":0,"telmarche":0,"date":"2073-04-01","time":"00:00:00"},
        targets:[]
      },
      title: "Global",
      dialog:"",
      search:"",
      target:{},
      A_Update_targets : null,

      objet :"",
      ra:"",
      dec:"",
    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){
    
    this.update_nuit();

    this.click_nuit = this.nuit;

    this.get_Cal();
    this.load_Cal();

    this.get_Journalisation();
    this.load_Journalisation();

    this.A_get_Journalisation = setInterval(() => {

      this.get_Journalisation();

    },1000);

    this.A_Get_Cal = setInterval(() => {
        this.get_Cal();
        
    },10000);

    this.A_update = setInterval(() => {
      this.load_Cal();
      this.update_nuit();
      this.load_Journalisation();

    },1000);
    


  },
  destroyed: function () {
    clearInterval(this.A_get_Journalisation);
    clearInterval(this.A_Get_Cal);
    clearInterval(this.A_update);
  },

  methods: {

    Annuler_obs(){
      this.D_edit_tblreport_obs = false;
    },

    Sauvegarder_obs(){
      const othis=this;
        
      var url = "";
      url = backend_url + "/journalisationbeta/update_obs "; //+this.a_report.id


      //console.log(this.a_report);
      this.D_edit_tblreport_obs = false;
      
      this.axios.post(url,this.a_report)
        .then((res) => {

          //console.log("all is good");
          ////!!!!! othis.loading_ot = false;
          

        })
        .catch((error) => {
          /////// !!!!!!!!  othis.loading_ot = false;
          console.error(error);
          console.log("ERR_update_tblreport_Obs");

        });
      
    },

    Sauvegarder_allobs(){
      const othis=this;
        
      var url = "";
      url = backend_url + "/journalisationbeta/update_allobs "; //+this.a_report.id

      var tmp_Obs = JSON.parse(JSON.stringify(this.data_journalisation));
      this.a_report_nuit.liste_ids = [];
      for(var t_obs of tmp_Obs){
        this.a_report_nuit.liste_ids.push(t_obs.id);

      }
      //console.log(this.a_report_nuit);
      //alert("roule on est bon");
      this.D_edit_tblreport_obs = false;
      
      this.axios.post(url,this.a_report_nuit)
        .then((res) => {

          //console.log("all is good");
          ////!!!!! othis.loading_ot = false;
          

        })
        .catch((error) => {
          /////// !!!!!!!!  othis.loading_ot = false;
          console.error(error);
          console.log("ERR_update_tblreport_Obs");

        });
      
    },
    edit_tblreport_obs(item){
      this.a_report = Object.assign({}, item)
      this.D_edit_tblreport_obs = true;
      //this.dialog_calendar = true;
      //console.log(item);
    },
    click_a_la_con(item){
      console.log("clik !!!!!");
      //console.log(item);
    },
    open_calendar(){
      this.dialog_calendar_old = true;
    },
    close_calendar(){
      console.log("close");
      this.dialog_calendar = false;
    },
    update_nuit(){
      this.nuit = g.v.nuit,
      this.nuit_l = g.v.nuit_l,
      this.neo_nuit = g.v.neo_nuit

    },
    get_Journalisation(){
      //console.log("gogo");
      const othis = this;
      if(this.nuit != this.click_nuit){
        this.axios.post( backend_url + "/journalisationbeta/date/",{"date":this.click_nuit})
        .then((res) => {

            othis.swap.click_data_journalisation = JSON.parse(JSON.stringify(res.data.table));
            this.click_data_journalisation = JSON.parse(JSON.stringify(othis.swap.click_data_journalisation));
            //console.log(res.data);
            
        })
        .catch(() => {
          console.log("PB with load Journalisation clicked");
        });
      }

      this.axios.post( backend_url + "/journalisationbeta/date/",{"date":this.nuit})
      .then((res) => {

          othis.swap.data_journalisation = JSON.parse(JSON.stringify(res.data.table));
          this.data_journalisation = JSON.parse(JSON.stringify(othis.swap.data_journalisation));
          //console.log(res.data);
          
      })
      .catch(() => {
        console.log("PB with load Journalisation");
      });

    },
    load_Journalisation(){
      this.data_journalisation = JSON.parse(JSON.stringify(this.swap.data_journalisation));
    },



    Sauvegarder_obs(){
      const othis=this;
        
      var url = "";
      url = backend_url + "/journalisationbeta/update_obs "; //+this.a_report.id

        console.log("a report");
      //console.log(this.a_report);
      this.D_edit_tblreport_obs = false;
      
      this.axios.post(url,this.a_report)
        .then((res) => {

          console.log("all is good");

          ////!!!!! othis.loading_ot = false;
          

        })
        .catch((error) => {
          /////// !!!!!!!!  othis.loading_ot = false;
          console.error(error);
          console.log("ERR_update_tblreport_Obs");

        });
      

    },
      edit_tblreport_obs(item){
      this.a_report = Object.assign({}, item)
      this.D_edit_tblreport_obs = true;
      //this.dialog_calendar = true;
      //console.log(item);
     },  

      report_nuit_close(){
        this.d_tecnical_report_nuit = false;
      },

      dateClick(event){
          
          //console.log(event);
          const othis = this;
          this.click_nuit = event.date;
          this.d_tecnical_report_nuit = true;

          this.axios.post( backend_url + "/journalisationbeta/date/",{"date":this.nuit})
          .then((res) => {

              othis.swap.data_journalisation = JSON.parse(JSON.stringify(res.data.table));
              this.data_journalisation = JSON.parse(JSON.stringify(othis.swap.data_journalisation));
              //console.log(res.data);
              
          })
          .catch(() => {
            console.log("PB with load Targets");
          });


      },

      get_Cal(){

        const othis = this;


        this.axios.get( backend_url + "/journalisationbeta/calendarOLD")
        .then((res) => {

            othis.L_Observations = JSON.parse(JSON.stringify(res.data));
            
        })
        .catch(() => {
          console.log("PB de récupérations des données");
        });

      },
      load_Cal(){

        this.Observations = JSON.parse(JSON.stringify(this.L_Observations));
        
      },
      getEvents ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        this.events = events
      },
      getEventColor (event) {
        return event.color
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },

  },

  
    data () {
      return {

        click_nuit : "",
        nuit:"",
        nuit_l:"",
        neo_nuit:"",

        d_tecnical_report_nuit : false,
        L_Observations : [],
        Observations : [],
        type: 'month',
        types: ['month', 'week', 'day', '4day'],
        mode: 'stack',
        modes: ['stack', 'column'],
        weekday: [0, 1, 2, 3, 4, 5, 6],
        weekdays: [
          { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
          { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
          { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
          { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
        ],
        value: '',
        events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party','luka water poney'],


        c_status:[
          "Done",
          "Other",
          "Astronomy",
          "NC",
          "Technical Failure - Instrument",
          "Meteo",
          "Technical Failure - Telescope"
        ],
        sample_a_report:{

          "hour": "20:40:00",
          "prioprog": "0",
          "prioog": "0",
          "miss": "N02",
          "nom_og": "Vega_2023_A",
          "nom_objet": "Vega",
          "ha1": "-1.54",
          "ha2": "4.70",
          "am1": "1.05",
          "am2": "1.62",
          "magv": "0.03",
          "spt": "A0Va",
          "tt": "22419",
          "ts": "9600",
          "p": "A",
          "m": "V",
          "l": "n",
          "commentaires": "Undone",
          "state": "Undone",
          "remarks": "",
          "id": "23095",
          "valider": "1",
          "undefined": "<input type=\"radio\" id=\"yes\" name=\"validate[23095]\" checked value=\"0\"No</radio</tr"

        },
        a_report_nuit:{


          "state": "Undone",
          "remarks": "",
          "liste_ids" :[]

        },
        a_report:{

          "hour": "00:00:00",
          "prioprog": "0",
          "prioog": "0",
          "miss": "Nxx",

          "nom_og": "og_name",

          "nom_objet": "Objet",

          "ha1": "-0.0",
          "ha2": "0.0",

          "am1": "0.00",
          "am2": "0.00",

          "magv": "0.00",
          "spt": "spt",

          "tt": "0",
          "ts": "0",
          "p": "A",
          "m": "V",
          "l": "n",

          "commentaires": "Undone",
          "state": "Undone",
          "remarks": "",
          "id": "0",
          "valider": "1",
          "undefined": "<input type=\"radio\" id=\"yes\" name=\"validate[0]\" checked value=\"0\"No</radio</tr"

        },


        D_edit_tblreport_obs : false,
        D_edit_tblreport_full : false,
        A_load_Journalisation : false,
        A_get_Journalisation : false,
        nuit : "2029-04-01",
        dialog: false,
        dialog_calendar_old : false,
        swap: {
          info : {},
          data_journalisation : []
        },
        dialog_calendar : false,
        la_date: "2005-08-22",
        headers: [
          { text: 'Heure', value: 'hour' },
          { text: 'Miss.', value: 'miss' },
          { text: 'Nom_OG', value: 'nom_og' },
          { text: 'Status', value: 'state' },
          { text: 'Remarks', value: 'remarks' }
         ],
        headers_old: [
          { text: 'Heure', value: 'hour' },
          { text: 'Prio Prog', value: 'prioprog' },
          { text: 'Prio OG', value: 'prioog' },
          { text: 'Miss.', value: 'miss' },
          { text: 'Nom_OG', value: 'nom_og' },
          { text: 'Nom_Objet', value: 'nom_objet' },
          { text: 'TT[s]', value: 'tt' },
          { text: 'TS[s]', value: 'ts' },
          { text: 'P', value: 'p' },
          { text: 'M', value: 'm' },
          { text: 'L', value: 'l' },
          { text: 'Status', value: 'state' },
          { text: 'Remarks', value: 'remarks' }
         ],
        full: [
          { text: 'Heure', value: 'Hour' },
          { text: 'Prio Prog', value: 'PrioProg' },
          { text: 'Prio OG', value: 'PrioOG' },
          { text: 'Miss.', value: 'MISS' },
          { text: 'Nom_OG', value: 'NOM_OG' },
          { text: 'Nom_Objet', value: 'NOM_OBJET' },
          { text: 'H.A.', value: 'HA1' },
          { text: '', value: 'HA2' },          
          { text: 'A.M', value: 'AM1' },
          { text: '', value: 'AM2' },
          { text: 'Mag.V', value: 'MagV' },
          { text: 'Sp.T', value: 'SpT' },
          { text: 'TT[s]', value: 'TT' },
          { text: 'TS[s]', value: 'TS' },
          { text: 'P', value: 'P' },
          { text: 'M', value: 'M' },
          { text: 'L', value: 'L' },
          { text: 'Status', value: 'State' },
          { text: 'Remarks', value: 'Remarks' }
        ],
        data_journalisation: [
        ],
        click_data_journalisation: [
        ],
      }
    },
  }
</script>